import { Tooltip } from 'antd'
import { Link } from '../balises/fiche'
import { ENV } from './constant'

// ------------------------------------------ CONSTRUCT HOME URL  ------------------------------------------

export const constructUrl = (fiche, audience) => {
    let url
    if (!isNil(fiche)) {
        url = `${audience.toLowerCase()}/${fiche}`
    } else {
        url = `/${audience.toLowerCase()}`
    }

    return ENV?.wp?.home_url + 'sp/' + url + '/'
}

/**
 *
 * @context This function is used to replace all the occurences of a string in a string
 * @param {String} str
 * @param {String} find
 * @param {String} replace
 * @returns {String}
 */
export const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find, 'g'), replace)
}

// ------------------------------------------ Constantes ------------------------------------------

const blocks = {
    exponent: 'Exposant',
    toKnowMore: 'PourEnSavoirPlus',
    warning: 'Avertissement',
    whoCanHelpMe: 'QuiPeutMAider',
    seeAsWell: 'VoirAussi',
    questionAnswer: 'QuestionReponse',
    onlineService: 'ServiceEnLigne',
    reference: 'Reference',
    title: 'Titre',
    text: 'Texte',
    webResource: 'RessourceWeb',
    complement: 'Complement',
    linkExternal: 'LienExterne',
    linkInternal: 'LienInterne',
    linkIntra: 'LienIntra',
    expression: 'Expression',
    value: 'Valeur',
    highlight: 'MiseEnEvidence',
}

//  ------------------------------------------ UTILS ------------------------------------------
/**
 *
 * @param {String} dateFormatted
 * @returns {String}
 * @context This function is used to format the date
 */

export const formatteDate = (dateFormatted) => {
    const date = new Date(dateFormatted)
    const formattedDate = date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })
    return formattedDate
}

// ------------------------------------------ BLOCKS ------------------------------------------

/**
 * return the block by type
 * @param {Array} childrens
 * @param {String } type
 * @returns {Object || Array}
 */

export const filterBlockByType = (childrens, type) => {
    if (!childrens) {
        return [] || null
    }

    if (!type) {
        let filters = []
        const block = childrens
        block?.childrens?.forEach((childs) => {
            const types = [blocks.complement, blocks.title, blocks.text, blocks.webResource]
            const filtered = childs?.childrens?.filter((child) => !types.includes(child.block))
            if (filtered) {
                filters.push(...filtered)
            }
        })
        return filters
    } else {
        return childrens?.find((child) => child.block === type)
    }
}

/**
 *
 * @param {Array} blocks
 * @param {Array} selectValue
 * @returns {Array}
 * @context This function is used to filter the blocks by condition affectTrue and affectFalse
 */

export const filterBlockByCondition = (blocks, selectValue) => {
    const affectTrueArray = selectValue.map((item) => item.affectTrue)
    const affectFalseArray = selectValue.map((item) => item.affectFalse)

    const hasUndefined = affectFalseArray.includes(undefined)

    if (isEmpty(selectValue)) {
        return blocks
    }

    const filterBlocks = (blocks) => {
        if (!blocks) {
            return []
        }

        return blocks
            .filter((block) => {
                const attributes = block?.attributes
                const condition = attributes?.condition

                if (attributes && condition) {
                    return !condition.some(
                        (cond) =>
                            (cond.type === 'ou' &&
                                !hasUndefined &&
                                cond.var.some(
                                    (v) => v.type === 'estFaux' && affectFalseArray.includes(v.var)
                                )) ||
                            (cond.type === 'estVrai' && !affectTrueArray.includes(cond.var))
                    )
                }
                return true
            })

            .map((block) => {
                const blockCopy = { ...block }
                if (blockCopy?.childrens) {
                    blockCopy.childrens = filterBlocks(blockCopy.childrens)
                }
                return blockCopy
            })
    }

    return filterBlocks(blocks)
}

export const hasBlock = (block, blockName) => {
    return block?.some((child) => child.block === blockName)
}

// ------------------------------------------ SHORTCODES ------------------------------------------

export const decodeHtml = (html) => {
    var txt = document.createElement('span')
    txt.innerHTML = html
    return txt.textContent
}

const generateElementFromPart = (part, innerText, attributes) => {
    const types = ['Acronyme', 'Sigle']
    switch (part) {
        case blocks.linkInternal:
            if (types.includes(attributes.type)) {
                return (
                    <Tooltip title={decodeHtml(attributes.tooltip)} placement="bottom">
                        <span className="baseocom-link-internal-tooltip">{innerText}</span>
                    </Tooltip>
                )
            } else {
                return (
                    <Link url={constructUrl(attributes?.LienPublication, attributes?.audience)}>
                        {innerText}
                    </Link>
                )
            }
        case blocks.linkExternal:
            return (
                <Link targetBlank={true} url={attributes.URL}>
                    {innerText}
                </Link>
            )
        case blocks.expression:
            return <span className="baseocom-expression">{innerText}</span>
        case blocks.linkIntra:
            return (
                <Tooltip title={decodeHtml(attributes.tooltip)} placement="bottom">
                    <span className="baseocom-link-intra-tooltip">{innerText}</span>
                </Tooltip>
            )
        case blocks.exponent:
            return <span className="baseocom-exponent">{innerText}</span>
        case blocks.value:
        case blocks.highlight:
            return <strong className="baseocom-highlight">{innerText}</strong>
        default:
            return innerText
    }
}

/**
 *
 * @param {String} text
 * @returns {JSX.Element}
 * @context This function is used to replace shortcodes with HTML tags
 */

export const convertShortcodesToHTML = (text) => {
    if (!text) {
        return
    }
    const convert = (text) => {
        const shortcodeRegex = /\[(\w+)(.*?)\](.*?)\[\/\1\]/g
        const attributeRegex = /(\w+)="(.*?)"/g
        const parts = text.split(shortcodeRegex)

        const jsx = parts.map((part, index) => {
            if (index % 4 === 0) {
                return part
            } else if (index % 4 === 1) {
                const attributesString = parts[index + 1]
                const attributes = {}
                let match
                while ((match = attributeRegex.exec(attributesString)) !== null) {
                    attributes[match[1]] = match[2]
                }

                const innerText = convert(parts[index + 2])

                return generateElementFromPart(part, innerText, attributes)
            }
        })
        return <>{jsx}</>
    }

    return convert(text)
}

export const isEmpty = (obj) => {
    if (obj === null || obj === undefined) return true

    if (typeof obj === 'string' || Array.isArray(obj)) return obj.length === 0

    return Object.keys(obj).length === 0
}

export const isNil = (value) => {
    return value === null || value === undefined || value === ''
}
